module.exports = __webpack_public_path__ + "img/calendar.4c8e659b.svg";